/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

//Import PageHeader
import PageHeader from "../../components/PageHeader";

import { useHistory } from "react-router";
// Redux Store
import queryString from "query-string";
import { shallowEqual, useSelector } from "react-redux";
import Companies from "../../components/Company/Companies";
import PartnerCompanies from "../../components/Company/PartnerCompanies";
//import RequestCompanies from "../../components/Company/RequestCompanies";

import PartnerRequestCompanies from "../../components/Partner/PartnerRequestCompanies";

const AdminCompanies = () => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState();
  const { user } = useSelector(
    (store) => ({
      user: store.Profile.user,
    }),
    shallowEqual
  );
  const _setActiveTab = (value) => {
    history.push(`/admin/${value}?tab=${value}`);
  };
  const tabList = [
    {
      label: "등록기업",
      action: _setActiveTab,
      value: "companies",
    },
    {
      label: "파트너",
      action: _setActiveTab,
      value: "partners",
    },
    {
      /*
      label: (
        <>
          요청기업 <small className="color-red-100 font-size-10">new</small>
          
        </>
      ),
      */
      label: (
        <>
          무료버전 기업확인 <small className="color-red-100 font-size-10">new</small>

        </>
      ),
      action: _setActiveTab,
      value: "request-companies",
    },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);

  return (
    <>
      <PageHeader
        title={`안녕하세요, ${user && user.name}님.`}
        activeTab={activeTab}
        tabList={tabList}
      // buttons={headerButtons}
      />
      {activeTab === "companies" && <Companies />}
      {activeTab === "partners" && <PartnerCompanies />}
      {activeTab === "request-companies" && (
        //<RequestCompanies/>
        <PartnerRequestCompanies />
      )}
    </>
  );
};

export default AdminCompanies;
